export default {
	common: {
		searchForm: {
			query: 'Consultar',
			reset: 'Restablecer'
		},
		tableCom: {
			noData: 'Sin datos',
			total: 'Total',
			page: 'Página',
			pageSize: 'Elementos por página',
			confirm: 'Confirmar',
			cancel: 'Cancelar',
			action: 'Acción',
			view: 'Ver',
			edit: 'Editar',
			delete: 'Eliminar',
			batchDelete: 'Eliminar en lote',
			upload: 'Subir',
			download: 'Descargar',
			preview: 'Vista previa',
			pleaseSelect: 'Por favor seleccione',
			operationSuccess: 'Operación exitosa',
			operationFailed: 'Operación fallida',
			loading: 'Cargando...',
			required: 'Este campo es requerido'
		},
		onlinePreview: {
			preview: 'Vista previa',
			notSupport: 'Tipo de archivo no soportado para vista previa'
		},
		attachmentList: {
			title: 'Lista de adjuntos',
			upload: 'Subir archivo',
			download: 'Descargar',
			delete: 'Eliminar',
			preview: 'Vista previa',
			uploadSuccess: 'Subida exitosa',
			uploadFailed: 'Error al subir',
			deleteSuccess: 'Eliminación exitosa',
			deleteFailed: 'Error al eliminar',
			confirmDelete: '¿Está seguro de eliminar este archivo?',
			fileTooLarge: 'El tamaño del archivo no puede superar {size}MB',
			onlyOneFile: 'Solo se permite un archivo',
			maxFiles: 'Máximo {max} archivos'
		},
		detailDialog: {
			detail: 'Detalles',
			close: 'Cerrar',
			noFiles: 'Sin archivos',
			unnamedFile: 'Archivo sin nombre'
		},
		startStopRecord: {
			timeline: 'Línea de Tiempo de Inicio-Parada del Dispositivo',
			deviceName: 'Nombre del Dispositivo',
			deviceNo: 'Número del Dispositivo',
			status: 'Estado',
			startTime: 'Hora de Inicio',
			endTime: 'Hora de Fin',
			checkProject: 'Elemento de Verificación',
			checkMethod: 'Método de Verificación',
			runTime: 'Tiempo de Funcionamiento',
			stopTime: 'Tiempo de Parada',
			dateRangePlaceholder: 'Seleccionar Rango de Fechas',
			running: 'Funcionando',
			stopped: 'Detenido'
		}
	},
	passwordForm: {
		oldPassword: 'Contraseña anterior',
		newPassword: 'Nueva contraseña',
		confirmPassword: 'Confirmar contraseña',
		oldPasswordPlaceholder: 'Ingrese la contraseña anterior',
		newPasswordPlaceholder: 'Ingrese la nueva contraseña',
		confirmPasswordPlaceholder: 'Confirme la nueva contraseña',
		required: '{field} es requerido',
		passwordNotMatch: 'Las contraseñas no coinciden',
		passwordLength: 'La longitud debe estar entre {min} y {max} caracteres',
		submit: 'Enviar',
		reset: 'Restablecer'
	},
	appDownload: {
		title: 'Descarga de APP móvil',
		qrcodeTip: 'Escanea el código QR para descargar la APP',
		manualTitle: 'Manual de operación',
		manualPreview: 'Manual de operación'
	},
	aiAssistant: {
		title: 'Asistente AI',
		history: 'Historial',
		newChat: 'Nueva conversación',
		noMoreHistory: 'No hay más historial',
		noHistory: 'Sin historial',
		loading: 'Cargando...',
		selectModel: 'Seleccionar modelo',
		resetChat: 'Restablecer conversación',
		recommendedQuestions: 'Preguntas recomendadas',
		thinking: 'Pensando...',
		inputPlaceholder: 'Ingrese su pregunta...',
		welcomeMessage: '¡Hola! Soy su asistente AI, ¿en qué puedo ayudarle?',
		question1: '¿Cómo localizar rápidamente la causa de una alarma anormal del dispositivo?',
		question2: '¿Cómo formular un plan efectivo de mantenimiento preventivo de dispositivos?',
		question3: '¿Cómo solucionar anomalías en la recopilación de datos del dispositivo?',
		question4: '¿Cómo optimizar la eficiencia de operación del dispositivo?',
		question5: '¿Cómo determinar el ciclo de mantenimiento del dispositivo?',
		yesterday: 'Ayer',
		daysAgo: 'Hace {days} días',
		connectionError: 'Error de conexión, verifique la red',
		connectionErrorMessage: 'Error de conexión, verifique la red.'
	},
	printQrcode: {
		size: 'Tamaño',
		color: 'Color',
		qrcode: 'Código QR',
		print: 'Imprimir',
		download: 'Descargar imagen'
	},
	lazyImage: {
		loading: 'Cargando...'
	},
	performance: {
		loadTime: 'Tiempo de carga de página',
		domReady: 'DOM listo',
		fcp: 'Primera representación de contenido',
		lcp: 'Representación de contenido más grande',
		fid: 'Retraso de primera entrada',
		cls: 'Cambio acumulativo de diseño'
	},
	charts: {
		noData: 'Sin datos',
		emptyState: {
			noDataTitle: 'No hay datos recopilados en el período actual',
			noDataDesc: 'Seleccione otro período de tiempo o verifique el estado de recopilación de datos',
			loadErrorTitle: 'Error al cargar datos',
			loadErrorDesc: 'Actualice e intente nuevamente',
			networkErrorTitle: 'Error de conexión de red',
			networkErrorDesc: 'Verifique la red e intente nuevamente'
		},
		peakCount: {
			title: 'Tabla de espectro de picos',
			index: 'Índice',
			frequency: 'Frecuencia (Hz)',
			amplitude: 'Amplitud'
		},
		rotFre: {
			title: 'Análisis de Velocidad de Rotación',
			basic: 'Configuración básica',
			speed: 'Velocidad de rotación (r/min):',
			base: 'Rotación (Hz):',
			count: 'Cantidad de Múltiplos:',
			preview: 'Vista previa de múltiplos de velocidad',
			tip: 'Al confirmar se trazan líneas marcadas en múltiplos enteros de la frecuencia de rotación correspondiente a la velocidad de rotación. Pulse de nuevo la herramienta para cerrar',
			baseRequired: 'Introduzca una velocidad de rotación mayor que 0'
		},
		highChart: {
			delete: 'Eliminar',
			peakFind: 'Buscar Pico',
			screenshot: 'Captura de pantalla',
			setModel: 'Configurar Modelo',
			setFreCount: 'Configurar Cantidad de Bandas de Frecuencia',
			setMarkPoint: 'Configurar Punto de Marca',
			deletePoint: 'Eliminar Punto de Marca',
			setCharFre: 'Configurar Frecuencia Característica',
			setPeakCount: 'Configurar Cantidad de Picos',
			setAbnormal: 'Configurar Observación Anormal',
			singleMarkPointMode: 'Modo de Punto de Marca Único',
			singleMarkPointModeClose: 'Modo de Punto de Marca Único Cerrado',
			freCountSet: 'Cantidad de bandas de frecuencia configurada a {count}',
			modelAnnotateSuccess: 'Anotación exitosa',
			downloadSuccess: 'Descarga exitosa',
			screenshotSaveSuccess: 'Captura de pantalla guardada exitosamente',
			screenshotFailed: 'Error en la captura de pantalla',
			abnormalRemarkSaved: 'Observación anormal guardada',
			alreadyMarked: 'Este nodo ya ha sido marcado, por favor seleccione otro nodo',
			baseline: 'Línea Base',
			auxiliaryLine: 'Línea Auxiliar',
			peak: 'Pico',
			freSideInterval: 'Intervalo de Banda Lateral',
			rotFreLabel: 'Velocidad de rotación',
			noDataCollected: 'No hay datos recopilados en el período actual',
			noDataDesc: 'Seleccione otro período de tiempo o verifique el estado de recopilación de datos',
			dataLoadFailed: 'Error al cargar datos',
			dataLoadFailedDesc: 'Intente nuevamente más tarde o contacte al administrador',
			networkError: 'Error de conexión de red',
			networkErrorDesc: 'Verifique la conexión de red e intente nuevamente'
		}
	},
	dateRange: {
		to: 'a',
		startDate: 'Fecha de inicio',
		endDate: 'Fecha de fin'
	},
	maReport: {
		title: 'Selección de informe',
		fileName: 'Nombre del informe',
		deviceName: 'Nombre del dispositivo',
		createTime: 'Fecha de creación'
	},
	deviceModelLibrary: {
		configDeviceModel: 'Configurar modelo de dispositivo',
		selectDeviceType: 'Por favor seleccione tipo de dispositivo',
		addModelImage: 'Agregar imagen de modelo',
		editModelImage: 'Editar imagen de modelo'
	},
	devicePlm: {
		deviceBasicInfo: 'Información básica del dispositivo',
		editDeviceBasicInfo: 'Editar información básica del dispositivo'
	},
	maOrg: {
		selectOrg: 'Selección de organización',
		name: 'Nombre',
		parentName: 'Nombre del padre'
	},
	maOrgTree: {
		placeholder: 'Ingrese palabras clave para filtrar',
		expandAll: 'Expandir todo',
		collapseAll: 'Colapsar todo'
	},
	generateForm: {
		addDetail: 'Agregar detalle',
		clickUpload: 'Hacer clic para subir',
		fileUploadSuccess: 'Archivo subido exitosamente',
		fileUploadTimeout: 'Tiempo de subida agotado, por favor vuelva a subir',
		fileInfoIncomplete: 'La información del archivo está incompleta, no se puede eliminar',
		fileDeleteSuccess: 'Archivo eliminado exitosamente',
		fileDeleteFailed: 'Error al eliminar el archivo',
		fileDeleteRequestFailed: 'Error en la solicitud de eliminación del archivo',
		exceedUploadLimit: 'Se excedió el límite de subida',
		operation: 'Acción',
		delete: 'Eliminar'
	},
	maDevice: {
		selectDevice: 'Selección de dispositivo',
		deviceId: 'ID del dispositivo',
		deviceName: 'Nombre del dispositivo',
		number: 'Número',
		location: 'Ubicación',
		department: 'Departamento',
		keyType: 'Criticidad'
	},
	maRole: {
		selectRole: 'Selección de rol',
		name: 'Nombre',
		code: 'Código',
		remark: 'Observación'
	},
	maPost: {
		selectPost: 'Selección de puesto',
		postCode: 'Código de puesto',
		postName: 'Nombre del puesto'
	},
	maInspectDevice: {
		selectDevice: 'Selección de dispositivo',
		deviceId: 'ID del dispositivo',
		deviceName: 'Nombre del dispositivo',
		department: 'Departamento'
	},
	maOrgInspect: {
		selectOrg: 'Selección de organización',
		name: 'Nombre',
		parentName: 'Nombre del padre'
	},
	maDianjian: {
		title: 'Proyectos de inspección',
		projectId: 'ID del proyecto',
		projectName: 'Proyecto de inspección',
		method: 'Método de inspección'
	},
	hooks: {
		action: 'Acción',
		confirm: 'Confirmar',
		cancel: 'Cancelar',
		deleteConfirm: '¿Está seguro de que desea eliminar?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		downloadSuccess: 'Descarga exitosa'
	},
	zyForm: {
		confirm: 'Confirmar',
		cancel: 'Cancelar',
		validationFailed: '¡Validación fallida!',
		requiredField: '¡{field} es requerido!'
	},
	maUpload: {
		upload: 'Subir',
		uploading: 'Subiendo',
		success: 'Subida exitosa',
		fail: 'Subida fallida',
		image: {
			edit: 'Editar',
			view: 'Ver',
			delete: 'Eliminar'
		}
	}
}
